import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {MenuService} from '@emm/core/services/menu.service';

@Injectable({
    providedIn: 'root'
})
export class MenuTreeFacadeBasicService { // alternative direct flow not using NgRx store

    constructor(private menuService: MenuService) {}

    getSubmenuCacheEnabled(): Observable<boolean> {
        return this.menuService.getSubmenuCacheEnabled();
    }

    clearSubmenuCache(): Observable<any> {
        return this.menuService.deleteCacheByName('submenus');
    }

}
